const technoColors = {
  TECHNO_50: '#FDF6E3',
  TECHNO_100: '#F9E7B9',
  TECHNO_200: '#F3D98B',
  TECHNO_900: '#835B03',
}

export default technoColors
